import type { FeatureDefinitionNext } from '@central-products/bootstrapper';
import { AccountActionsInterface } from '@central-products/interface-account-actions';
import { AccountActions } from './AccountActions';

const FEATURE_NAME = '@feature/account-actions';

export const feature: FeatureDefinitionNext = {
  name: FEATURE_NAME,
  create: (config) => new AccountActions(config),
  init: (instance) => instance.init(),
  implements: AccountActionsInterface,
  dependsOn: [],
  role: 'account-actions',
};
